// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__PAATp","selects":"Documents_selects__UGtxw"};